
import state from './authState.js'
import mutations from './authMutations.js'
import actions from './authAction.js'
import getters from './authGetters.js'

export default {
  state,
  mutations,
  actions,
  getters
}

